import {
  EKwikUICheckboxContentAlign,
  EKwikUICheckboxSize,
  EKwikUICheckboxVarient
} from "./checkbox.definitions";

export const DEFAULT_VALUES = {
  contentAlign: EKwikUICheckboxContentAlign.LEFT,
  disabled: false,
  focus: false,
  formControlName: "form_control_checkbox_labeled",
  id: "checkbox_labeled",
  invalid: false,
  label: "Labeled Checkbox",
  placeholder: "Please select Labeled Checkbox",
  size: EKwikUICheckboxSize.M,
  variant: EKwikUICheckboxVarient.BLOCK
};

export const VALIDATE_KEY_VALUES = {
  contentAlign: true,
  disabled: true,
  focus: true,
  formControlName: true,
  id: true,
  invalid: true,
  label: true,
  placeholder: true,
  size: true
};
